import Empty from 'constants/empty';
import { createSelector } from 'reselect';
import { testTargetOffersSelector } from 'selectors/testTarget/offers/testTargetOffersSelector';

/**
 * Selects the Free Shipping Progress Bar ATB offer from Adobe Target offers.
 *
 * @param {object} state Redux state.
 * @returns {object} The offer payload, or Empty.Object when missing.
 */
const freeShippingProgressBarAtbSelector = createSelector(testTargetOffersSelector, offers => offers.freeShippingProgressBarAtb || Empty.Object);

export { freeShippingProgressBarAtbSelector };
